import React from "react";

/** Normaliza matrícula: 8 dígitos ou "C" + 8 dígitos */
export const normalizeMatricula = (raw: string) => {
  let v = raw.toUpperCase().replace(/[^0-9C]/g, "");
  v = v.replace(/(?!^)C/g, "");
  const max = v.startsWith("C") ? 9 : 8;
  return v.slice(0, max);
};

export const isMatriculaValida = (v: string) => /^(\d{8}|C\d{8})$/.test(v.trim());
export const isValidEmail = (v: string) => /^\S+@\S+\.\S+$/.test(v.trim());

/** Evita ghost-click ao trocar de view no mesmo ponto da tela */
export const safeSwitch =
  (cb: () => void) =>
  (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setTimeout(cb, 0); // ou requestAnimationFrame(cb)
  };
